<script setup lang="ts">
import { computed } from 'vue'
import StreakBar from '@/components/StreakBar.vue'
import GoldenWheelOverlayBackground from '@/assets/images/goldwheel-overlay-bg.webp'
import FortuneWheel from '@/components/FortuneWheel.vue'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useGoldWheel } from '@/composables/game/fortune-wheel'
import CrossCircleIcon from '@/components/icons/CrossCircleIcon.vue'
import { useWatchOverlays } from '@/composables/helpers/scoll'
import { useFullScreenDimensions } from '@/composables/helpers/fullscreen'

const props = defineProps<{
  show: boolean
}>()

const { streak } = useGoldWheel()

const { topStyle } = useFullScreenDimensions()
useWatchOverlays(computed(() => props.show))

</script>
<template>
  <Transition
    name="fade"
    mode="out-in"
  >
    <div
      v-if="show"
      class="fixed h-screen max-h-dvh w-screen overflow-hidden left-0 bottom-0 flex flex-col z-[800] bg-dark-most-bottom-layer/[65%] backdrop-blur-[50px]"
    >
      <div class=" w-screen h-screen flex flex-col items-center justify-center relative">
        <CrossCircleIcon
          class="w-6 h-6 min-w-[24px] absolute top-3 right-3 text-black z-[6]"
          :style="topStyle"
        />
        <img
          :src="GoldenWheelOverlayBackground"
          class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-[400px] h-auto w-[946px] max-w-none"
        >
        <div class="w-[500px] h-[500px] absolute -top-2 -translate-y-1/2 left-1/2 -translate-x-1/2 flex flex-col">
          <FortuneWheel
            :is-spinning="false"
            :spin-multiplier="1"
            is-gold
            only-visual
            class="w-full"
          />
        </div>
        <div class="flex flex-col w-full max-w-[330px] z-[3] pt-[100px]">
          <h1 class="text-white text-[36px] font-bold leading-[42px] text-center mb-3">
            <T
              key-name="fortune_wheel.congratulations"
              default-value="Congratulations!"
            />
          </h1>
          <p class="text-center text-lg font-medium -tracking-[0.36px] w-full general-sans-text mb-8">
            <T
              key-name="fortune_wheel.gold.description"
              default-value="You've completed your streak and unlocked the Golden Wheel! Spin it now!"
            />
          </p>
          <StreakBar
            :streak="streak"
            class="mb-9 w-full"
            all-done
          />
          <BaseButton
            style-type="gold"
            class="w-full"
          >
            <T
              key-name="fortune_wheel.gold.description"
              default-value="Reveal the wheel now"
            />
          </BaseButton>
        </div>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.general-sans-text {
  font-family: 'General Sans', sans-serif;
}
</style>
